import {useTheme} from "@mui/material/styles";
import {useParams} from "react-router-dom";
import {getI18nContent} from "../../config/i18nConfig";
import {useState} from "react";
import {NODE_ROUTE_URI, PARTNER_URI} from "../../Utils/apiUrl";
import axios from "axios";
import {
    Alert, Box,
    Button,
    Card,
    CardContent,
    Divider,
    FormControl, FormControlLabel,
    Grid,
    InputAdornment, Radio, RadioGroup,
    Skeleton,
    TextField, Typography
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {WordPressToolsTrackingLTL} from "./WordPressToolsTrackingLTL";
import {WordPressToolsTrackingParcel} from "./WordPressToolsTrackingParcel";

export const WordPressToolsMoving = () => {

    const theme = useTheme();
    const {lng} = useParams();
    const uiText = getI18nContent(lng, 'LTLTools');

    const [searchValue, setSearchValue] = useState('');
    const [trackingData, setTrackingData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const retrieveLTLTrackingForConsignee = async () => {

        if (!searchValue.trim()) return;

        try {
            setLoading(true);
            setError(false);
            setTrackingData(null);

            const requestURL = `${PARTNER_URI}/shippingLTLTracking/retrieveLTLTrackingForConsignee`;
            const result = await axios({
                method: 'get',
                url: requestURL,
                params: {
                    bolNumber: searchValue.trim()
                }
            });

            setTrackingData(result.data);

            setError(false);
        } catch (e) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    const handleSearchValue = (event) => {
        const {value} = event.target;
        setSearchValue(value);
    }

    const handleSearch = async () => {
        await retrieveLTLTrackingForConsignee()
    }

    return (
        <Grid container spacing={1}>
            <Grid size={{md: 12, xs: 12}}>
                <FormControl fullWidth>
                    <TextField
                        value={searchValue}
                        fullWidth
                        variant='outlined'
                        required
                        label={`${uiText.search.label}: ${uiText.search.types.bol}`}
                        placeholder={uiText.search.placeholder}
                        onInput={handleSearchValue}
                        size='small'
                        slotProps={{
                            input: {
                                sx: {
                                    borderRadius: theme.shape.lg,
                                    backgroundColor: theme.palette.background.default,
                                    transition: '0.3s',
                                },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={handleSearch}
                                            startIcon={<SearchIcon fontSize="small"/>}
                                            sx={{
                                                textTransform: 'none',
                                                borderRadius: theme.shape.lg,
                                            }}
                                        >
                                            {uiText.search.button.track}
                                        </Button>
                                    </InputAdornment>
                                ),
                            },
                            inputLabel: {
                                sx: {...theme.typography.caption}
                            },
                            htmlInput: {
                                sx: {...theme.typography.caption}
                            }
                        }}
                    />
                </FormControl>
            </Grid>
            {loading && (
                <Grid size={{xs: 12}}>
                    <Card sx={{mt: 2, borderRadius: theme.shape.lg}}>
                        <CardContent>
                            <Skeleton variant="text" width="40%" height={30}/>
                            <Divider sx={{my: 2}}/>
                            <Skeleton variant="rectangular" height={60} sx={{mb: 1, borderRadius: 1}}/>
                            <Skeleton variant="rectangular" height={60} sx={{borderRadius: 1}}/>
                        </CardContent>
                    </Card>
                </Grid>
            )}
            {error && (
                <Grid size={{xs: 12}}>
                    <Alert severity="error" icon={<ErrorOutlineIcon/>} sx={{mt: 2, borderRadius: theme.shape.lg}}>
                        {uiText.search.error}
                    </Alert>
                </Grid>
            )}
            {(!loading && !error && trackingData?.trackingResponse?.activity?.length === 0) && (
                <Grid size={{xs: 12}}>
                    <Box sx={{textAlign: 'center', py: 5}}>
                        <Typography color="text.secondary" variant="body2">
                            {uiText.search.noData}
                        </Typography>
                    </Box>
                </Grid>
            )}
            {(!loading && !error && trackingData?.trackingResponse?.activity?.length > 0) && (
                <Grid size={{xs: 12}}>
                    <WordPressToolsTrackingLTL trackingData={trackingData} isLongDistanceMoving={true}/>
                </Grid>
            )}
        </Grid>
    )
}